import { useQuery } from "@tanstack/react-query";
import { api } from "./api";
import { PR } from "./components/settings/PRTiles";

export function usePersonalRecords() {
  return useQuery<PR[]>({
    queryKey: ["personal-records"],
    queryFn: async () => {
      const r = await api.get<PR[]>("/athlete/personal-records");
      return r.data;
    },
    staleTime: 5 * 60_000,
  });
}
